<script type="text/javascript">
  // Site Layout
  export default {
    props: ['website'],
    data() {
      return {
        title: 'REVINRE',


      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">Site Layout:</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <ul class="pl-3">
              <li>
                <h3>Current pages:</h3>
                <ul class="pl-5">
                  <li>
                    Home
                    <ul class="pl-5 text-blue">
                      <li>Maybe use our ideas for the REVINRE actual page on the home page. I think having the first thing visitors see be a walkthrough of exactly what we do would be more valuable than our packages/services.</li>
                    </ul>
                  </li>
                  <li>
                    Sell
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Buy
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Full Service
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Buying
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Home valuation
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    How it works
                    <ul class="pl-5 text-blue">
                      <li>This page could use a lot of work. The REVINRE actual page could also be used here to improve our explanation of services. With an easy to follow design and then some verbiage from Chat GPT this could be improved greatly.</li>
                    </ul>
                  </li>
                  <li>
                    Preferred partners
                    <ul class="pl-5 text-blue">
                      <li>This is still only visible to REVINRE staff. We could get this up and running for more potential lead collection.</li>
                    </ul>
                  </li>
                  <li>
                    Testimonials
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Blog
                    <ul class="pl-5 text-blue">
                      <li>It could be worthwhile to take a look at our HubSpot blog, get that up and running quickly and start a scheduled once a month post using ChatGPT to get some basic verbiage down. Maybe have a deadline for each employee to provide a list of blog ideas each month.</li>
                    </ul>
                  </li>
                  <li>
                    FAQ
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Contact us
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Login
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Register
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    My Profile
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    My Listings
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    My Favorites
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Privacy policy
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Terms of service
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h3 class="mt-5">Future pages:</h3>
                <ul class="pl-5">
                  <li>
                    Investor page
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Corporate page
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Pricing / packages / services page.
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    FSBO page
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    Careers page
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

        </div>
      </section>


    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
